let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7ZGuC")).then(() => parcelRequire('a2cJp'));